import React, { PureComponent } from "react";
import VisibilitySensor from "react-visibility-sensor";

import styles from "./Gallery.local.scss";
import classnames from "classnames";

import MediaContainer from "../Media/MediaContainer";
import _ from "i18n";

export default class GalleryComponent extends PureComponent {
  state = {
    listElement: null
  };

  componentDidMount() {
    this.setListElement();
  }

  setListElement = () => {
    setTimeout(() => {
      const listElement = document.getElementById("media-list");
      this.setState({ listElement });
    });
  };

  loadMore = isVisible => {
    const { medias = [], loadMore } = this.props;
    if (!isVisible || medias.length === 1) {
      return;
    }

    if (loadMore) {
      loadMore();
    }
  };

  renderFetching = () => {
    const { fetching } = this.props;

    if (!fetching) {
      return;
    }

    return [...Array(9).keys()].map(key => (
      <li key={key} className={classnames(styles.fetching, "small-4")}>
        <span />
      </li>
    ));
  };

  renderVisibilitySensore = () => {
    const { hasMore, fetching } = this.props;

    if (!this.state.listElement || !hasMore || fetching) {
      return;
    }

    return (
      <VisibilitySensor onChange={this.loadMore}>
        {({ isVisible }) => (
          <li
            className="cell small-12"
            style={{ height: "1rem", visibility: "hidden" }}
          >
            VisibilitySensor is {isVisible ? "visible" : "invisible"}
          </li>
        )}
      </VisibilitySensor>
    );
  };

  render() {
    const { community, fetched, medias } = this.props;

    if (!fetched || !medias || medias.length === 0) {
      return (
        <div className={styles.notFound}>
          <img src="/img/notFound.svg" alt="Not found" />
          <span>{_("No result found")}</span>
        </div>
      );
    }
    return (
      <ul id="media-list" className="grid-x">
        {medias.map(media => (
          <li
            className="cell small-4"
            key={`media-container-${media.id}-${Math.random()}`}
          >
            <MediaContainer media={media} community={community} />
          </li>
        ))}

        {this.renderFetching()}
        {this.renderVisibilitySensore()}
      </ul>
    );
  }
}

// Conn



// WEBPACK FOOTER //
// ./src/components/Community/Common/Gallery/GalleryComponent.js